





















































import {Component, Inject} from "vue-property-decorator";
import Api from "./Api";
import {Company, ExportserviceHeaderRow} from "../../modules/models";
import CompanyUserRequired from "../CompanyRequired";

@Component
export default class ExportserviceSettingspage extends CompanyUserRequired {
    @Inject()
    api!: Api;

    loadedExportserviceRows: ExportserviceHeaderRow[] = [];
    currentExportserviceRows: ExportserviceHeaderRow[] = [];

    confirmDeactivateIdx = -1;
    get confirmDeactivate() {
        return this.confirmDeactivateIdx > -1;
    }
    set confirmDeactivate(v: boolean) {
        this.confirmDeactivateIdx = v ? 0 : -1;
    }
    get confirmDeactivateRow(): ExportserviceHeaderRow | null {
        return this.confirmDeactivateIdx > -1 ? this.currentExportserviceRows[this.confirmDeactivateIdx] : null;
    }
    showMsg = "";
    activating = false;

    async update(idx: number) {
        this.showMsg = "";
        this.activating = true;
        try {
            const loaded = this.loadedExportserviceRows[idx];
            const row = this.currentExportserviceRows[idx];
            this.showMsg = await this.api.exportserviceSettingsCRUD(this.company.orgNum, "update", row.id, row.description, row.urlSio, row.username, row.secret, row.authMethod);
            await this.loadExportserviceRows(); // Refresh page
        } catch (err) {
            this.emitError(err);
        } finally {
            this.activating = false;
        }
    }
    async deactivate() {
        this.showMsg = "";
        this.activating = true;
        try {
            if(this.confirmDeactivateRow != null) {
                this.showMsg = await this.api.exportserviceSettingsCRUD(this.company.orgNum, "deactivate", this.confirmDeactivateRow.id, null, null, null, null, ExportserviceHeaderRow.authMethodBasic);
                this.confirmDeactivate = false;
                await this.loadExportserviceRows(); // Refresh page
            } else {
                throw new Error("confirmDeactivateRow null");
            }
        } catch (err) {
            this.emitError(err);
        } finally {
            this.activating = false;
        }
    }

    async loadExportserviceRows() {
        this.loadedExportserviceRows = await this.api.fetchExportserviceHeaderRows(this.company.orgNum);
        this.currentExportserviceRows = this.loadedExportserviceRows.map((r) => r.copy());
    }

    created() {
        // TODO replace with vuex store, avoid use of the promise method
        this.baseApi.loadCompanyPromise().then(() => {
            this.loadExportserviceRows();
        });
    }
}

